export default __webpack_public_path__ + "locales/sl/Files.json?hash=2eeeff66b3e299b2f9198e0e45a9271c";